import { fuseProvisioningConstants } from "../_redux-constants";
import { fuseProvisioningService } from "../../_services";

function getFuseProvisioning(queryParams) {
  function getFuseProvisioningLoad() {
    return { type: fuseProvisioningConstants.FUSE_PROVISIONING_LOADING };
  }
  function FuseProvisioningSuccess(data) {
    return { type: fuseProvisioningConstants.FUSE_PROVISIONING_SUCCESS, data };
  }
  function FuseProvisioningFailure(error) {
    return { type: fuseProvisioningConstants.FUSE_PROVISIONING_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(getFuseProvisioningLoad());
    fuseProvisioningService.getFuseProvisioning(queryParams).then(
      (data) => {
        dispatch(FuseProvisioningSuccess(data));
      },
      (error) => {
        dispatch(FuseProvisioningFailure(error?.toString()));
      }
    );
  };
}

export const fuseProvisioningActions = {
  getFuseProvisioning,
};
